import { getLocalization } from 'global/global';
import { ChartModel } from 'Interfaces/ChartInterface';
import * as React from 'react';
import { Dropdown, Form } from 'react-bootstrap';

interface Props {
  model: ChartModel;
  targetValue?: string;
  onModelUpdate: (model: ChartModel) => void;
}

export default function ChartSettings(props: Props) {
  const { model } = props;

  const [showSettingsDropdown, setShowSettingsDropdown] = React.useState(false);

  const onToggleSettingsDropDown = (isOpen, metadata) => {
    if (metadata.source === 'select') {
      setShowSettingsDropdown(true);
    } else {
      setShowSettingsDropdown(isOpen);
    }
  };

  const handleOptionCheck = (e) => {
    const tempModel: Partial<ChartModel> = {};
    if (e.target.checked) {
      if (e.target.name === 'vericalBars') {
        tempModel.verticalBars = '1';
      } else if (e.target.name === 'showMissingXAxisNumericValues') {
        tempModel.showMissingXAxisNumericValues = '1';
      } else if (e.target.name === 'excludenull') {
        tempModel.excludeNull = '1';
      } else {
        tempModel[e.target.name] = true;
      }
    } else {
      if (e.target.name === 'vericalBars') {
        tempModel.verticalBars = undefined;
      } else if (e.target.name === 'excludenull') {
        tempModel.excludeNull = undefined;
      } else if (e.target.name === 'showMissingXAxisNumericValues') {
        tempModel.showMissingXAxisNumericValues = undefined;
      } else {
        tempModel[e.target.name] = false;
      }
    }
    props.onModelUpdate({...model, ...tempModel});
  };

  const barChartOptions = () => {
    const options: JSX.Element[] = [(
      <Dropdown.Item as="div" key={`chart-settings-down-checkbox-vertical-bars`}>
        <Form.Check
          id={`chart-settings-down-checkbox-vertical-bars`}
          type={'checkbox'}
          label={getLocalization('chartsVerticalBars')}
          onChange={handleOptionCheck}
          name={'vericalBars'}
          checked={model.verticalBars === '1'}
        />
      </Dropdown.Item>
    ), (
      <Dropdown.Item as="div" key={`chart-settings-down-checkbox-missing-x-axis-values`}>
        <Form.Check
          id={`chart-settings-down-checkbox-missing-x-axis-values`}
          type={'checkbox'}
          label={getLocalization('showMissingXNumericValues')}
          onChange={handleOptionCheck}
          name={'showMissingXAxisNumericValues'}
          checked={model.showMissingXAxisNumericValues === '1'}
        />
      </Dropdown.Item>
    )];
    return options;
  };

  return (
    <Dropdown
      className="chart-content-spacing"
      onToggle={onToggleSettingsDropDown}
      show={showSettingsDropdown}
    >
      <Dropdown.Toggle variant="primary" id="chart-settings-dropdown" size="sm">
        <i className="fa fa-cog" />
      </Dropdown.Toggle>
      <Dropdown.Menu className="chart-questions-drop-down">
        {/* All charts */}
        <Dropdown.Item as="div">
          <Form.Check
            id={`chart-settings-down-checkbox-excludenull`}
            type={'checkbox'}
            label={getLocalization('chartsExcludenull')}
            onChange={handleOptionCheck}
            name={'excludenull'}
            checked={model.excludeNull === '1'}
          />
        </Dropdown.Item>
        {/* Not for pie chart*/}
        {/* Line & Bar Chart */}
        {(`${model.type}` === 'LINE_NUMERIC' || `${model.type}` === 'BAR_NUMERIC') && (
          <Dropdown.Item as="div">
            <Form.Check
              id={`chart-settings-down-checkbox-line-average`}
              type={'checkbox'}
              label={getLocalization('chartsShowAverage')}
              onChange={handleOptionCheck}
              name={'average'}
              checked={model.average === true}
            />
          </Dropdown.Item>
        )}
        {/* Bar Chart only */}
        {(`${model.type}` === 'BAR_NUMERIC' || `${model.type}` === 'BAR_CHOICE') &&
          barChartOptions()}
        {model.type === 'LINE_NUMERIC' && (
          <>
            <Dropdown.Item as="div">
              <Form.Check
                id={`chart-settings-down-checkbox-target-line`}
                type={'checkbox'}
                label={getLocalization('targetLine')}
                onChange={handleOptionCheck}
                name={'targetLine'}
                checked={model.targetLine === true}
                disabled={!props.targetValue}
              />
            </Dropdown.Item>
            <Dropdown.Header>{getLocalization('trendLine')}</Dropdown.Header>
            <Dropdown.Item as="div">
              <Form.Check
                id={`chart-settings-down-checkbox-linear-average`}
                type={'checkbox'}
                label={getLocalization('linearAverage')}
                onChange={handleOptionCheck}
                name={'linearAverage'}
                checked={model.linearAverage === true}
              />
            </Dropdown.Item>
            <Dropdown.Item as="div">
              <Form.Check
                id={`chart-settings-down-checkbox-moving-average`}
                type={'checkbox'}
                label={getLocalization('movingAverage')}
                onChange={handleOptionCheck}
                name={'movingAverage'}
                checked={model.movingAverage === true}
              />
            </Dropdown.Item>
            <Dropdown.Item as="div">
              <Form.Label>{getLocalization('input')}</Form.Label>
              <Form.Control
                id={`chart-settings-down-input-averages`}
                type={'number'}
                size="sm"
                value={model.averageInput}
                onChange={(e) => props.onModelUpdate({ ...model, averageInput: Number(e.target.value)})}
                name={'averageInput'}
              />
            </Dropdown.Item>
          </>
        )}
        {/* model.type !== 'PIE' && model.type !== 'RADAR' && (
          <Dropdown.Item as="div">
            <Form.Check
              id={`chart-settings-down-checkbox-show-form-name`}
              type={'checkbox'}
              label={getLocalization('showFormNameInChart')}
              onChange={handleOptionCheck}
              name={'showFormName'}
              checked={model.showFormName === true}
            />
          </Dropdown.Item>
        )*/}
      </Dropdown.Menu>
    </Dropdown>
  );
}
